<ng-container *ngIf="itemPath; then withHref else withoutHref"></ng-container>
<ng-template #withHref>
  <a
    [href]="itemPath"
    class="items-list-item cursor-pointer"
    [attr.data-e2e]="e2e"
    [ngClass]="{'disabled': isDisabled, 'highlight': isHighlight}"
    [ecmDisabledAction]="!isDisabled && isDisabledEclair"
    (click)="materialItemListConfirm();false"
    ecmTarget
  >
    <ng-container *ngTemplateOutlet="itemListContent"></ng-container>
  </a>
</ng-template>
<ng-template #withoutHref>
  <div class="items-list-item">
    <ng-container *ngTemplateOutlet="itemListContent"></ng-container>
  </div>
</ng-template>
<ng-template #itemListContent>
  <span
    *ngIf="itemIcon && itemIcon.startsWith('icon-')"
    class="item-icon"
    [ngClass]="itemIcon"
    aria-hidden="true"
  ></span>
  <img *ngIf="itemIcon && !itemIcon.startsWith('icon-')" [src]="itemIcon" [alt]="itemAlt" class="item-img" />
  <div class="item-container" [ngClass]="{'item-loading': isLoading, 'no-border-bottom': hasNoBorder}">
    <div class="item-text">
      <span [attr.data-e2e]="e2e.concat('-label')">{{ itemLabel }}</span>
      <small
        *ngFor="let item of displayedText; let index = index"
        [attr.data-e2e]="e2e.concat('-text-', index.toString())"
        class="item-desc"
      >
        {{item}}
      </small>
    </div>
    <span
      *ngIf="itemStatus"
      class="item-status"
      [attr.data-e2e]="e2e.concat('status')"
      [ngClass]="getCssClassFromStatus(itemStatus)"
      aria-hidden="true"
    ></span>
    <div *ngIf="isLoading" class="ob1-spinner-determined spinner">
      <div class="ob1-spinner-determined-loader1 spinner-loader1"></div>
      <div class="ob1-spinner-determined-loader2 spinner-loader2"></div>
    </div>
  </div>
</ng-template>
